/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 6538:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {


// EXTERNAL MODULE: ./src/js/utils/create-vue-section.js
var create_vue_section = __webpack_require__(5720);
// EXTERNAL MODULE: ./node_modules/vue/dist/vue.cjs.js
var vue_cjs = __webpack_require__(388);
// EXTERNAL MODULE: ./src/js/utils/icons.js
var icons = __webpack_require__(113);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(4728);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[8].use[0]!./src/js/vue/buyBoxV2/BuyBoxV2Description.vue?vue&type=script&setup=true&lang=ts


var _hoisted_1 = {
    class: "flex w-full flex-col font-bold text-zinc-900 max-md:max-w-full",
    role: "main",
    "aria-labelledby": "description-title"
};
var _hoisted_2 = {
    id: "description-title",
    class: "text-4xl leading-none max-md:max-w-full"
};
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = { class: "mt-4 flex w-fit max-w-full text-center leading-none text-sm gap-[40px] max-md:hidden" };
var _hoisted_5 = ["aria-labelledby", "innerHTML"];
var _hoisted_6 = { class: "my-auto whitespace-nowrap" };



/* harmony default export */ const BuyBoxV2Descriptionvue_type_script_setup_true_lang_ts = ((0,vue_cjs.defineComponent)({
    __name: 'BuyBoxV2Description',
    props: {
        product: {}
    },
    setup: function (__props) {
        var props = __props;
        var product = (0,vue_cjs.toRefs)(props).product;
        return function (_ctx, _cache) {
            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", _hoisted_1, [
                (0,vue_cjs.createElementVNode)("h1", _hoisted_2, (0,vue_cjs.toDisplayString)((0,vue_cjs.unref)(product).title), 1),
                (0,vue_cjs.createElementVNode)("p", {
                    class: "mt-4 min-h-[48px] w-full rounded-none leading-6 text-lg max-md:max-w-full font-normal [&>ul>li>ul]:list-disc [&>ul>li>ul>li]:ml-4 [&>ul>li>ul>li]:my-2",
                    innerHTML: (0,vue_cjs.unref)((sanitize_html_default()))((0,vue_cjs.unref)(product).description)
                }, null, 8, _hoisted_3),
                (0,vue_cjs.createElementVNode)("div", _hoisted_4, [
                    ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)((0,vue_cjs.unref)(product).tastingNotes, function (note) {
                        return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", {
                            key: note,
                            class: "flex flex-1 items-center gap-2 shrink basis-0"
                        }, [
                            (0,vue_cjs.createElementVNode)("span", {
                                "aria-labelledby": "".concat(note, " flavor icon"),
                                loading: "lazy",
                                class: "my-auto aspect-square w-6 shrink-0 object-contain self-stretch",
                                innerHTML: (0,vue_cjs.unref)(icons/* getTastingNotesIcon */.bS)(note)
                            }, null, 8, _hoisted_5),
                            (0,vue_cjs.createElementVNode)("div", _hoisted_6, (0,vue_cjs.toDisplayString)(note), 1)
                        ]));
                    }), 128))
                ])
            ]));
        };
    }
}));

;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/BuyBoxV2Description.vue?vue&type=script&setup=true&lang=ts
 
;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/BuyBoxV2Description.vue



const __exports__ = BuyBoxV2Descriptionvue_type_script_setup_true_lang_ts;

/* harmony default export */ const BuyBoxV2Description = (__exports__);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[8].use[0]!./src/js/vue/buyBoxV2/BuyBoxV2Flavor.vue?vue&type=script&setup=true&lang=ts


var BuyBoxV2Flavorvue_type_script_setup_true_lang_ts_hoisted_1 = {
    key: 0,
    class: "flex flex-col w-full text-base leading-none text-zinc-900 max-md:max-w-full",
    role: "region",
    "aria-label": "Taste preference selection"
};
var BuyBoxV2Flavorvue_type_script_setup_true_lang_ts_hoisted_2 = { class: "flex gap-1 items-center self-start font-bold relative" };
var BuyBoxV2Flavorvue_type_script_setup_true_lang_ts_hoisted_3 = (0,vue_cjs.createElementVNode)("div", { class: "self-stretch my-auto" }, "Flavor", -1);
var BuyBoxV2Flavorvue_type_script_setup_true_lang_ts_hoisted_4 = { class: "flex w-full relative after:content-[''] after:absolute after:top-[115%] after:left-0 after:border-solid after:border-t-[10px] after:border-r-[9px] after:border-l-[9px] after:border-t-[#1a1a1a] after:border-r-transparent after:border-l-transparent" };
var BuyBoxV2Flavorvue_type_script_setup_true_lang_ts_hoisted_5 = { class: "text-white text-xs font-normal leading-4 mb-0 w-[95%] sm:text-sm sm:leading-5" };
var BuyBoxV2Flavorvue_type_script_setup_true_lang_ts_hoisted_6 = ["innerHTML"];
var _hoisted_7 = ["innerHTML"];
var _hoisted_8 = {
    class: "grid grid-cols-4 gap-2 items-stretch mt-2.5 w-full max-md:max-w-full max-md:grid-cols-2",
    role: "group",
    "aria-label": "Coffee roast preferences"
};
var _hoisted_9 = ["onClick", "aria-pressed"];
var _hoisted_10 = {
    key: 1,
    class: "flex flex-col justify-center px-4 py-2 w-full text-sm font-bold leading-none bg-[#F4EEE6] rounded-lg text-zinc-900 max-md:max-w-full",
    role: "banner"
};
var _hoisted_11 = { class: "flex flex-wrap gap-4 items-center w-full max-md:max-w-full" };
var _hoisted_12 = ["innerHTML"];
var _hoisted_13 = ["innerHTML"];


/* harmony default export */ const BuyBoxV2Flavorvue_type_script_setup_true_lang_ts = ((0,vue_cjs.defineComponent)({
    __name: 'BuyBoxV2Flavor',
    props: {
        product: {},
        productsList: {},
        tooltip: {},
        paymentOptions: {},
        recommendation: {}
    },
    emits: ['update:product'],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var _b = (0,vue_cjs.toRefs)(props), productsList = _b.productsList, tooltip = _b.tooltip, paymentOptions = _b.paymentOptions, recommendation = _b.recommendation;
        var tooltipOpened = (0,vue_cjs.ref)(false);
        var emit = __emit;
        var toggleTooltip = function () {
            tooltipOpened.value = !tooltipOpened.value;
        };
        var closeTooltip = function () {
            tooltipOpened.value = false;
        };
        var selectOption = function (selectedOption) {
            productsList.value.forEach(function (option) {
                option.selected = option.id === selectedOption.id;
            });
            var currentPaymentOption = paymentOptions.value.find(function (price) { return price.selected; });
            if (currentPaymentOption) {
                var newPaymentOption = paymentOptions.value.find(function (price) {
                    return price.name === currentPaymentOption.name &&
                        price.tier === selectedOption.tier;
                });
                if (newPaymentOption) {
                    paymentOptions.value.forEach(function (price) {
                        price.selected = false;
                    });
                    newPaymentOption.selected = true;
                    emit('update:product', selectedOption);
                }
            }
        };
        return function (_ctx, _cache) {
            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, [
                ((0,vue_cjs.unref)(productsList).length)
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", BuyBoxV2Flavorvue_type_script_setup_true_lang_ts_hoisted_1, [
                        (0,vue_cjs.createElementVNode)("div", BuyBoxV2Flavorvue_type_script_setup_true_lang_ts_hoisted_2, [
                            BuyBoxV2Flavorvue_type_script_setup_true_lang_ts_hoisted_3,
                            (0,vue_cjs.createElementVNode)("div", {
                                class: (0,vue_cjs.normalizeClass)(["bg-gray-900 p-3 max-w-sm rounded-xl transition-all duration-200 ease-in-out hover:cursor-pointer absolute top-[-100px] left-0 w-[343px]", {
                                        'visible opacity-100': tooltipOpened.value,
                                        'invisible opacity-0': !tooltipOpened.value,
                                    }])
                            }, [
                                (0,vue_cjs.createElementVNode)("div", BuyBoxV2Flavorvue_type_script_setup_true_lang_ts_hoisted_4, [
                                    (0,vue_cjs.createElementVNode)("p", BuyBoxV2Flavorvue_type_script_setup_true_lang_ts_hoisted_5, (0,vue_cjs.toDisplayString)((0,vue_cjs.unref)(tooltip)), 1),
                                    (0,vue_cjs.createElementVNode)("span", {
                                        onClick: (0,vue_cjs.withModifiers)(closeTooltip, ["prevent"]),
                                        class: "h-3 w-[4%]",
                                        innerHTML: (0,vue_cjs.unref)(icons/* toolTipCloseIcon */.vF)
                                    }, null, 8, BuyBoxV2Flavorvue_type_script_setup_true_lang_ts_hoisted_6)
                                ])
                            ], 2),
                            (0,vue_cjs.createElementVNode)("span", {
                                class: "cursor-pointer",
                                innerHTML: (0,vue_cjs.unref)(icons/* toolTipIcon */.bR),
                                onClick: (0,vue_cjs.withModifiers)(toggleTooltip, ["prevent"])
                            }, null, 8, _hoisted_7)
                        ]),
                        (0,vue_cjs.createElementVNode)("div", _hoisted_8, [
                            ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)((0,vue_cjs.unref)(productsList), function (option) {
                                return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("button", {
                                    key: option.id,
                                    class: (0,vue_cjs.normalizeClass)([
                                        'p-4 rounded-lg border border-solid box-content max-md:box-border hover:border-zinc-900',
                                        option.selected
                                            ? 'bg-gray-100 border-zinc-900'
                                            : 'bg-white border-neutral-200',
                                    ]),
                                    onClick: function ($event) { return (selectOption(option)); },
                                    "aria-pressed": option.selected
                                }, (0,vue_cjs.toDisplayString)(option.type), 11, _hoisted_9));
                            }), 128))
                        ])
                    ]))
                    : (0,vue_cjs.createCommentVNode)("", true),
                ((0,vue_cjs.unref)(recommendation))
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", _hoisted_10, [
                        (0,vue_cjs.createElementVNode)("div", _hoisted_11, [
                            (0,vue_cjs.createElementVNode)("span", {
                                innerHTML: (0,vue_cjs.unref)(icons/* infoBulbIcon */.t3),
                                role: "img",
                                "aria-label": "Information",
                                focusable: "false"
                            }, null, 8, _hoisted_12),
                            (0,vue_cjs.createElementVNode)("div", {
                                innerHTML: (0,vue_cjs.unref)(recommendation),
                                class: "flex-1 shrink self-stretch my-auto basis-0 decoration-auto decoration-solid underline-offset-auto max-md:max-w-full [&_a]:underline"
                            }, null, 8, _hoisted_13)
                        ])
                    ]))
                    : (0,vue_cjs.createCommentVNode)("", true)
            ], 64));
        };
    }
}));

;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/BuyBoxV2Flavor.vue?vue&type=script&setup=true&lang=ts
 
;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/BuyBoxV2Flavor.vue



const BuyBoxV2Flavor_exports_ = BuyBoxV2Flavorvue_type_script_setup_true_lang_ts;

/* harmony default export */ const BuyBoxV2Flavor = (BuyBoxV2Flavor_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[8].use[0]!./src/js/vue/buyBoxV2/BuyBoxV2Dropdown.vue?vue&type=script&setup=true&lang=ts


var BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts_hoisted_1 = { class: "flex items-start rounded self-stretch" };
var BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts_hoisted_2 = { class: "flex flex-col w-full relative h-full" };
var BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts_hoisted_3 = ["id"];
var BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts_hoisted_4 = ["id", "aria-labelledby"];
var BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts_hoisted_5 = ["innerHTML"];
var BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts_hoisted_6 = {
    key: 0,
    class: "rounded-lg border border-gray-200 p-0 overflow-hidden absolute top-[110%] w-full z-10 bg-white shadow-md"
};
var BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts_hoisted_7 = ["onClick"];
var BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts_hoisted_8 = { class: "flex-1 my-auto" };


/* harmony default export */ const BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts = ((0,vue_cjs.defineComponent)({
    __name: 'BuyBoxV2Dropdown',
    props: {
        label: {},
        options: {},
        selected: {},
        dropdownId: {},
        labelId: {},
        optionKey: {}
    },
    emits: ['update:selected'],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var isOpen = (0,vue_cjs.ref)(false);
        var toggleDropdown = function () {
            isOpen.value = !isOpen.value;
        };
        var selectOption = function (option) {
            emit('update:selected', option);
            isOpen.value = false;
        };
        var handleClickOutside = function (event) {
            if (isOpen.value &&
                !event.target.closest("#".concat(props.dropdownId))) {
                isOpen.value = false;
            }
        };
        (0,vue_cjs.onMounted)(function () {
            window.addEventListener('click', handleClickOutside);
        });
        (0,vue_cjs.onUnmounted)(function () {
            window.removeEventListener('click', handleClickOutside);
        });
        return function (_ctx, _cache) {
            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts_hoisted_1, [
                (0,vue_cjs.createElementVNode)("div", BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts_hoisted_2, [
                    (0,vue_cjs.createElementVNode)("div", {
                        id: _ctx.labelId,
                        class: "text-base font-bold leading-none text-zinc-900"
                    }, (0,vue_cjs.toDisplayString)(_ctx.label), 9, BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts_hoisted_3),
                    (0,vue_cjs.createElementVNode)("button", {
                        id: _ctx.dropdownId,
                        onClick: toggleDropdown,
                        class: "flex gap-4 items-center p-4 mt-2.5 w-full bg-white rounded-lg border border-solid border-neutral-200 h-full",
                        "aria-labelledby": _ctx.labelId,
                        role: "button"
                    }, [
                        (0,vue_cjs.renderSlot)(_ctx.$slots, "selected-content", {}, function () {
                            var _a;
                            return [
                                (0,vue_cjs.createTextVNode)((0,vue_cjs.toDisplayString)((_a = _ctx.selected) === null || _a === void 0 ? void 0 : _a.label), 1)
                            ];
                        }),
                        (0,vue_cjs.createElementVNode)("span", {
                            innerHTML: (0,vue_cjs.unref)(icons/* arrowDownIcon */.Pu),
                            role: "img",
                            "aria-label": "Open Dropdown",
                            focusable: "false"
                        }, null, 8, BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts_hoisted_5)
                    ], 8, BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts_hoisted_4),
                    (isOpen.value)
                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts_hoisted_6, [
                            ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)(_ctx.options, function (option) {
                                return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", {
                                    key: option.label,
                                    onClick: function ($event) { return (selectOption(option)); },
                                    class: "flex gap-2 p-3 cursor-pointer hover:bg-gray-100"
                                }, [
                                    (0,vue_cjs.renderSlot)(_ctx.$slots, "option", { option: option }, function () { return [
                                        (0,vue_cjs.createElementVNode)("span", BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts_hoisted_8, (0,vue_cjs.toDisplayString)(option.label), 1)
                                    ]; })
                                ], 8, BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts_hoisted_7));
                            }), 128))
                        ]))
                        : (0,vue_cjs.createCommentVNode)("", true)
                ])
            ]));
        };
    }
}));

;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/BuyBoxV2Dropdown.vue?vue&type=script&setup=true&lang=ts
 
;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/BuyBoxV2Dropdown.vue



const BuyBoxV2Dropdown_exports_ = BuyBoxV2Dropdownvue_type_script_setup_true_lang_ts;

/* harmony default export */ const BuyBoxV2Dropdown = (BuyBoxV2Dropdown_exports_);
// EXTERNAL MODULE: ./src/js/utils/helpers.ts
var helpers = __webpack_require__(1481);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[8].use[0]!./src/js/vue/buyBoxV2/GrindSelector.vue?vue&type=script&setup=true&lang=ts
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};


var GrindSelectorvue_type_script_setup_true_lang_ts_hoisted_1 = { class: "flex flex-col w-full font-normal self-stretch" };
var GrindSelectorvue_type_script_setup_true_lang_ts_hoisted_2 = { class: "text-[18px] leading-[22px] font-bold text-[#1a1a1a] w-full m-0 grind-title" };
var GrindSelectorvue_type_script_setup_true_lang_ts_hoisted_3 = { class: "flex flex-row gap-2.5 items-start mt-2.5 w-full text-base leading-none text-center max-md:max-w-full grind-options" };
var GrindSelectorvue_type_script_setup_true_lang_ts_hoisted_4 = ["aria-pressed", "onClick", "data-sg-label", "data-sg-location"];
var GrindSelectorvue_type_script_setup_true_lang_ts_hoisted_5 = ["innerHTML"];
var GrindSelectorvue_type_script_setup_true_lang_ts_hoisted_6 = { class: "self-stretch my-auto" };



/* harmony default export */ const GrindSelectorvue_type_script_setup_true_lang_ts = ((0,vue_cjs.defineComponent)({
    __name: 'GrindSelector',
    props: {
        grindTypes: {},
        label: {},
        selected: {}
    },
    emits: ['update:selected'],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var grindTypes = __spreadArray([], props.grindTypes, true).sort(function (a, b) { return a.order - b.order; });
        var wholeGrindType = grindTypes.find(function (grindType) { return grindType.handle === 'whole'; });
        var coldBrewGrindType = grindTypes.find(function (grindType) { return grindType.handle === 'cold-brew'; });
        var currentGrindType = (0,vue_cjs.ref)(wholeGrindType);
        var unselectedGroundType = {
            label: 'Select Brew Method',
            handle: null,
        };
        var wholeOrGroundMode = (0,vue_cjs.computed)(function () { var _a; return ((_a = currentGrindType.value) === null || _a === void 0 ? void 0 : _a.handle) === 'whole' ? 'whole' : 'ground'; });
        var wholeOrGround = [
            {
                icon: icons/* wholeBeanIcon */.DA,
                grindType: wholeGrindType,
                mode: 'whole',
                label: 'Whole Bean',
            },
            {
                icon: icons/* groundIcon */.ZD,
                grindType: coldBrewGrindType,
                mode: 'ground',
                label: 'Ground',
            },
        ];
        var emit = __emit;
        var selectGrindType = function (grindType) {
            currentGrindType.value = grindType;
            emit('update:selected', grindType);
        };
        return function (_ctx, _cache) {
            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("section", GrindSelectorvue_type_script_setup_true_lang_ts_hoisted_1, [
                (0,vue_cjs.createElementVNode)("h2", GrindSelectorvue_type_script_setup_true_lang_ts_hoisted_2, (0,vue_cjs.toDisplayString)(props.label), 1),
                (0,vue_cjs.createElementVNode)("section", GrindSelectorvue_type_script_setup_true_lang_ts_hoisted_3, [
                    ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)(wholeOrGround, function (_a) {
                        var icon = _a.icon, grindType = _a.grindType, label = _a.label, mode = _a.mode;
                        return (0,vue_cjs.createElementVNode)("button", {
                            key: "".concat(label, "-").concat(grindType, "-").concat(mode),
                            class: (0,vue_cjs.normalizeClass)(["flex flex-1 shrink gap-2 justify-center items-center p-4 rounded-lg border border-solid basis-0 active:border-zinc-900 hover:border-[#1a1a1a] active:bg-[#eff2f6] grind-option", {
                                    'bg-white': mode !== wholeOrGroundMode.value,
                                    'border-neutral-200': mode !== wholeOrGroundMode.value,
                                    'bg-[#eff2f6]': mode === wholeOrGroundMode.value,
                                    'border-[#1a1a1a]': mode === wholeOrGroundMode.value,
                                }]),
                            "aria-pressed": mode === wholeOrGroundMode.value,
                            onClick: function ($event) { return (selectGrindType(grindType)); },
                            "data-sg-track": "true",
                            "data-sg-label": label,
                            "data-sg-sub-section": "grind-selection",
                            "data-sg-location": (0,vue_cjs.unref)(helpers/* getDocumentTitle */.EL)()
                        }, [
                            (0,vue_cjs.createElementVNode)("span", { innerHTML: icon }, null, 8, GrindSelectorvue_type_script_setup_true_lang_ts_hoisted_5),
                            (0,vue_cjs.createElementVNode)("span", GrindSelectorvue_type_script_setup_true_lang_ts_hoisted_6, (0,vue_cjs.toDisplayString)(label), 1)
                        ], 10, GrindSelectorvue_type_script_setup_true_lang_ts_hoisted_4);
                    }), 64))
                ])
            ]));
        };
    }
}));

;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/GrindSelector.vue?vue&type=script&setup=true&lang=ts
 
;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/GrindSelector.vue



const GrindSelector_exports_ = GrindSelectorvue_type_script_setup_true_lang_ts;

/* harmony default export */ const GrindSelector = (GrindSelector_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[8].use[0]!./src/js/vue/buyBoxV2/BuyBoxV2Grind.vue?vue&type=script&setup=true&lang=ts


var BuyBoxV2Grindvue_type_script_setup_true_lang_ts_hoisted_1 = {
    key: 1,
    class: "flex flex-col w-full text-base leading-none text-zinc-900 max-md:max-w-full relative",
    role: "region",
    "aria-label": "Grind type selection"
};
var BuyBoxV2Grindvue_type_script_setup_true_lang_ts_hoisted_2 = { class: "flex flex-wrap flex-1 shrink gap-[16px] items-center self-stretch my-auto basis-0 min-w-[220px] max-md:max-w-full" };
var BuyBoxV2Grindvue_type_script_setup_true_lang_ts_hoisted_3 = ["src", "alt"];
var BuyBoxV2Grindvue_type_script_setup_true_lang_ts_hoisted_4 = { class: "text-left" };
var BuyBoxV2Grindvue_type_script_setup_true_lang_ts_hoisted_5 = ["src", "alt"];
var BuyBoxV2Grindvue_type_script_setup_true_lang_ts_hoisted_6 = { class: "flex-1 my-auto" };



/* harmony default export */ const BuyBoxV2Grindvue_type_script_setup_true_lang_ts = ((0,vue_cjs.defineComponent)({
    __name: 'BuyBoxV2Grind',
    props: {
        grindTypeOptions: {},
        showGrindButtons: { type: Boolean }
    },
    setup: function (__props) {
        var props = __props;
        var _a = (0,vue_cjs.toRefs)(props), grindTypeOptions = _a.grindTypeOptions, showGrindButtons = _a.showGrindButtons;
        var selectedGrindType = (0,vue_cjs.computed)(function () {
            return grindTypeOptions.value.find(function (grind) { return grind.selected; });
        });
        var selectGrindType = function (grindType) {
            grindTypeOptions.value.forEach(function (option) {
                option.selected = option.handle === grindType.handle;
            });
        };
        return function (_ctx, _cache) {
            return ((0,vue_cjs.unref)(showGrindButtons))
                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(GrindSelector, {
                    key: 0,
                    "grind-types": (0,vue_cjs.unref)(grindTypeOptions),
                    selected: selectedGrindType.value,
                    "onUpdate:selected": selectGrindType,
                    label: "Select your grind"
                }, null, 8, ["grind-types", "selected"]))
                : ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", BuyBoxV2Grindvue_type_script_setup_true_lang_ts_hoisted_1, [
                    (0,vue_cjs.createVNode)(BuyBoxV2Dropdown, {
                        label: "Grind",
                        options: (0,vue_cjs.unref)(grindTypeOptions),
                        selected: selectedGrindType.value,
                        "onUpdate:selected": selectGrindType,
                        "dropdown-id": "grind-dropdown",
                        "label-id": "grind-label",
                        "option-key": "handle",
                        class: "w-full"
                    }, {
                        "selected-content": (0,vue_cjs.withCtx)(function () {
                            var _a, _b, _c;
                            return [
                                (0,vue_cjs.createElementVNode)("div", BuyBoxV2Grindvue_type_script_setup_true_lang_ts_hoisted_2, [
                                    (0,vue_cjs.createElementVNode)("img", {
                                        loading: "lazy",
                                        src: (_a = selectedGrindType.value) === null || _a === void 0 ? void 0 : _a.icon,
                                        alt: "".concat((_b = selectedGrindType.value) === null || _b === void 0 ? void 0 : _b.label, " icon"),
                                        class: "object-contain shrink-0 self-stretch my-auto w-6 aspect-square"
                                    }, null, 8, BuyBoxV2Grindvue_type_script_setup_true_lang_ts_hoisted_3),
                                    (0,vue_cjs.createElementVNode)("div", BuyBoxV2Grindvue_type_script_setup_true_lang_ts_hoisted_4, (0,vue_cjs.toDisplayString)((_c = selectedGrindType.value) === null || _c === void 0 ? void 0 : _c.label), 1)
                                ])
                            ];
                        }),
                        option: (0,vue_cjs.withCtx)(function (_a) {
                            var option = _a.option;
                            return [
                                (0,vue_cjs.createElementVNode)("img", {
                                    src: option.icon,
                                    alt: "".concat(option.label, " icon"),
                                    class: "w-6 h-6 object-contain"
                                }, null, 8, BuyBoxV2Grindvue_type_script_setup_true_lang_ts_hoisted_5),
                                (0,vue_cjs.createElementVNode)("span", BuyBoxV2Grindvue_type_script_setup_true_lang_ts_hoisted_6, (0,vue_cjs.toDisplayString)(option.label), 1)
                            ];
                        }),
                        _: 1
                    }, 8, ["options", "selected"])
                ]));
        };
    }
}));

;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/BuyBoxV2Grind.vue?vue&type=script&setup=true&lang=ts
 
;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/BuyBoxV2Grind.vue



const BuyBoxV2Grind_exports_ = BuyBoxV2Grindvue_type_script_setup_true_lang_ts;

/* harmony default export */ const BuyBoxV2Grind = (BuyBoxV2Grind_exports_);
// EXTERNAL MODULE: ./src/js/vue/buyBoxV2/icons/StandardBag.vue + 2 modules
var StandardBag = __webpack_require__(9073);
// EXTERNAL MODULE: ./src/js/vue/buyBoxV2/icons/BigBag.vue + 2 modules
var BigBag = __webpack_require__(6381);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[8].use[0]!./src/js/vue/buyBoxV2/BagSizeSelectButton.vue?vue&type=script&setup=true&lang=ts


var BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_1 = {
    key: 0,
    class: "absolute top-[-13px] left-0 right-0 flex justify-center text-[12px] leading-[16px]"
};
var BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_2 = { class: "py-1 px-2 rounded bg-[#FFD6AC]" };
var BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_3 = ["value"];
var BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_4 = ["src", "alt"];
var BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_5 = {
    key: 2,
    class: "px-2"
};
var BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_6 = {
    key: 3,
    class: "px-2"
};
var BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_7 = { class: "flex flex-col text-black gap-1 max-md:text-center" };
var BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_8 = { class: "text-[16px] leading-[20px]" };
var BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_9 = { class: "flex flex-row gap-[1px] items-center justify-start text-[12px] leading-[14px]" };
var BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_10 = (0,vue_cjs.createElementVNode)("svg", {
    class: "mx-[1px]",
    width: "8",
    height: "8",
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, [
    (0,vue_cjs.createElementVNode)("path", {
        d: "M4 5C4.55229 5 5 4.55229 5 4C5 3.44771 4.55229 3 4 3C3.44771 3 3 3.44771 3 4C3 4.55229 3.44771 5 4 5Z",
        fill: "black"
    })
], -1);



/* harmony default export */ const BagSizeSelectButtonvue_type_script_setup_true_lang_ts = ((0,vue_cjs.defineComponent)({
    __name: 'BagSizeSelectButton',
    props: {
        variant: {},
        optionTitle: {},
        imgSrc: {},
        bagSize: {},
        badge: {},
        option: {},
        selected: {}
    },
    emits: ['update:selected'],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var isSelected = (0,vue_cjs.computed)(function () { return props.selected && props.selected.size === props.option.size; });
        var emit = __emit;
        var selectOption = function (option) {
            emit('update:selected', option);
        };
        return function (_ctx, _cache) {
            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("label", {
                class: (0,vue_cjs.normalizeClass)(["flex flex-col md:flex-row basis-full self-stretch justify-start items-center gap-2 p-3 rounded-lg border border-solid cursor-pointer relative ease-in-out duration-150 transition-[border-color]", {
                        'border-[#4D4D4D] bg-[#EFF2F6]': isSelected.value,
                        'border-neutral-200 bg-white hover:border-[#4D4D4D]': !isSelected.value,
                    }])
            }, [
                (props.badge)
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_1, [
                        (0,vue_cjs.createElementVNode)("div", BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_2, (0,vue_cjs.toDisplayString)(props.badge), 1)
                    ]))
                    : (0,vue_cjs.createCommentVNode)("", true),
                (0,vue_cjs.createElementVNode)("input", {
                    type: "radio",
                    value: props.optionTitle,
                    onClick: _cache[0] || (_cache[0] = function ($event) { return (selectOption(props.option)); }),
                    class: "sr-only"
                }, null, 8, BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_3),
                (props.imgSrc)
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("img", {
                        key: 1,
                        loading: "lazy",
                        src: props.imgSrc,
                        class: "w-[56px] h-auto",
                        alt: "".concat(props.optionTitle, " Icon")
                    }, null, 8, BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_4))
                    : (props.bagSize === '310')
                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_5, [
                            (0,vue_cjs.createVNode)(StandardBag/* default */.A)
                        ]))
                        : ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_6, [
                            (0,vue_cjs.createVNode)(BigBag/* default */.A)
                        ])),
                (0,vue_cjs.createElementVNode)("div", BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_7, [
                    (0,vue_cjs.createElementVNode)("div", BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_8, (0,vue_cjs.toDisplayString)(props.optionTitle), 1),
                    (0,vue_cjs.createElementVNode)("div", BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_9, [
                        (0,vue_cjs.createElementVNode)("span", null, (0,vue_cjs.toDisplayString)(props.bagSize === '310' ? '10.93' : '32') + " oz", 1),
                        BagSizeSelectButtonvue_type_script_setup_true_lang_ts_hoisted_10,
                        (0,vue_cjs.createElementVNode)("span", null, "makes " + (0,vue_cjs.toDisplayString)(props.bagSize === '310' ? '20' : '60') + " cups", 1)
                    ])
                ])
            ], 2));
        };
    }
}));

;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/BagSizeSelectButton.vue?vue&type=script&setup=true&lang=ts
 
;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/BagSizeSelectButton.vue



const BagSizeSelectButton_exports_ = BagSizeSelectButtonvue_type_script_setup_true_lang_ts;

/* harmony default export */ const BagSizeSelectButton = (BagSizeSelectButton_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[8].use[0]!./src/js/vue/buyBoxV2/SizeAndFrequency.vue?vue&type=script&setup=true&lang=ts


var SizeAndFrequencyvue_type_script_setup_true_lang_ts_hoisted_1 = {
    class: "flex flex-wrap gap-2.5 w-full max-md:flex-col",
    role: "group",
    "aria-label": "Product options"
};
var SizeAndFrequencyvue_type_script_setup_true_lang_ts_hoisted_2 = { class: "flex flex-1 shrink gap-[8px] items-center self-stretch my-auto basis-0 min-h-[20px]" };
var SizeAndFrequencyvue_type_script_setup_true_lang_ts_hoisted_3 = { class: "self-stretch my-auto text-base leading-none text-zinc-900 text-left" };
var SizeAndFrequencyvue_type_script_setup_true_lang_ts_hoisted_4 = {
    key: 0,
    class: "gap-2.5 whitespace-nowrap px-2 py-1 my-auto text-xs leading-none text-black bg-orange-200 rounded max-lg:whitespace-pre-wrap max-sm:whitespace-nowrap",
    role: "status"
};
var SizeAndFrequencyvue_type_script_setup_true_lang_ts_hoisted_5 = (0,vue_cjs.createElementVNode)("h2", { class: "text-base font-bold leading-none text-zinc-900" }, " Select your Bag Size ", -1);
var SizeAndFrequencyvue_type_script_setup_true_lang_ts_hoisted_6 = { class: "gap-3 items-center mt-2.5 w-full max-md:max-w-full md:flex md:flex-row flex flex-row" };
var SizeAndFrequencyvue_type_script_setup_true_lang_ts_hoisted_7 = { class: "flex-1 shrink gap-2.5 self-stretch my-auto text-left" };
var SizeAndFrequencyvue_type_script_setup_true_lang_ts_hoisted_8 = { class: "self-stretch my-auto text-base leading-none text-zinc-900" };



/* harmony default export */ const SizeAndFrequencyvue_type_script_setup_true_lang_ts = ((0,vue_cjs.defineComponent)({
    __name: 'SizeAndFrequency',
    props: {
        planIntervalOptions: {},
        bagSizeOptions: {},
        paymentOptions: {},
        product: {}
    },
    setup: function (__props) {
        var props = __props;
        var _a = (0,vue_cjs.toRefs)(props), planIntervalOptions = _a.planIntervalOptions, bagSizeOptions = _a.bagSizeOptions, paymentOptions = _a.paymentOptions, product = _a.product;
        var isBagSizeHidden = (0,vue_cjs.computed)(function () {
            return bagSizeOptions.value.some(function (option) { return option.hideBagSize; });
        });
        var bagSizeDisplayType = (0,vue_cjs.computed)(function () {
            var bagSizeOption = bagSizeOptions.value.find(function (option) { return option.selected; });
            return bagSizeOption === null || bagSizeOption === void 0 ? void 0 : bagSizeOption.bagSizeDisplay;
        });
        var isIntervalHidden = (0,vue_cjs.computed)(function () {
            return planIntervalOptions.value.some(function (option) { return option.hideIntervalOption; });
        });
        var selectedInterval = (0,vue_cjs.computed)(function () {
            return planIntervalOptions.value.find(function (interval) { return interval.selected; });
        });
        var selectedBagSize = (0,vue_cjs.computed)(function () {
            return bagSizeOptions.value.find(function (size) { return size.selected; });
        });
        var selectInterval = function (selected) {
            planIntervalOptions.value.forEach(function (option) {
                option.selected = option.interval === selected.interval;
            });
        };
        var selectBagSize = function (selectedBag) {
            bagSizeOptions.value.forEach(function (option) {
                option.selected =
                    option.size === selectedBag.size &&
                        option.quantity === selectedBag.quantity;
            });
            paymentOptions.value.forEach(function (option) {
                option.selected =
                    option.default &&
                        option.bagSize === selectedBag.size &&
                        option.quantity === selectedBag.quantity &&
                        option.tier === product.value.tier;
            });
        };
        return function (_ctx, _cache) {
            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", SizeAndFrequencyvue_type_script_setup_true_lang_ts_hoisted_1, [
                (bagSizeDisplayType.value === 'dropdown')
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(BuyBoxV2Dropdown, {
                        key: 0,
                        label: "Size",
                        options: (0,vue_cjs.unref)(bagSizeOptions),
                        selected: selectedBagSize.value,
                        "onUpdate:selected": selectBagSize,
                        "dropdown-id": "size-dropdown",
                        "label-id": "size-label",
                        class: (0,vue_cjs.normalizeClass)(["flex-1 max-md:w-full", { hidden: isBagSizeHidden.value }])
                    }, {
                        "selected-content": (0,vue_cjs.withCtx)(function () {
                            var _a, _b, _c;
                            return [
                                (0,vue_cjs.createElementVNode)("div", SizeAndFrequencyvue_type_script_setup_true_lang_ts_hoisted_2, [
                                    (0,vue_cjs.createElementVNode)("div", SizeAndFrequencyvue_type_script_setup_true_lang_ts_hoisted_3, (0,vue_cjs.toDisplayString)((_a = selectedBagSize.value) === null || _a === void 0 ? void 0 : _a.label), 1),
                                    ((_b = selectedBagSize.value) === null || _b === void 0 ? void 0 : _b.badge)
                                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", SizeAndFrequencyvue_type_script_setup_true_lang_ts_hoisted_4, (0,vue_cjs.toDisplayString)((_c = selectedBagSize.value) === null || _c === void 0 ? void 0 : _c.badge), 1))
                                        : (0,vue_cjs.createCommentVNode)("", true)
                                ])
                            ];
                        }),
                        _: 1
                    }, 8, ["options", "selected", "class"]))
                    : ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, { key: 1 }, [
                        SizeAndFrequencyvue_type_script_setup_true_lang_ts_hoisted_5,
                        (0,vue_cjs.createElementVNode)("div", SizeAndFrequencyvue_type_script_setup_true_lang_ts_hoisted_6, [
                            ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)((0,vue_cjs.unref)(product).variants, function (variant, idx) {
                                var _a;
                                return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(BagSizeSelectButton, {
                                    key: 'product_variant_selector_radio_plain_with_variant_' + variant.id,
                                    variant: variant,
                                    "option-title": variant.option1,
                                    option: (0,vue_cjs.unref)(bagSizeOptions)[idx],
                                    "img-src": (_a = variant.featured_image) === null || _a === void 0 ? void 0 : _a.src,
                                    "bag-size": String(variant.weight),
                                    badge: (0,vue_cjs.unref)(bagSizeOptions)[idx].badge,
                                    label: "Size",
                                    "onUpdate:selected": function ($event) { return (selectBagSize((0,vue_cjs.unref)(bagSizeOptions)[idx])); },
                                    selected: selectedBagSize.value
                                }, null, 8, ["variant", "option-title", "option", "img-src", "bag-size", "badge", "onUpdate:selected", "selected"]));
                            }), 128))
                        ])
                    ], 64)),
                (0,vue_cjs.createVNode)(BuyBoxV2Dropdown, {
                    label: "Frequency",
                    options: (0,vue_cjs.unref)(planIntervalOptions),
                    selected: selectedInterval.value,
                    "onUpdate:selected": selectInterval,
                    "dropdown-id": "frequency-dropdown",
                    "label-id": "frequency-label",
                    class: (0,vue_cjs.normalizeClass)(["flex-1 max-md:w-full", { hidden: isIntervalHidden.value }])
                }, {
                    "selected-content": (0,vue_cjs.withCtx)(function () {
                        var _a;
                        return [
                            (0,vue_cjs.createElementVNode)("div", SizeAndFrequencyvue_type_script_setup_true_lang_ts_hoisted_7, [
                                (0,vue_cjs.createElementVNode)("div", SizeAndFrequencyvue_type_script_setup_true_lang_ts_hoisted_8, (0,vue_cjs.toDisplayString)((_a = selectedInterval.value) === null || _a === void 0 ? void 0 : _a.label), 1)
                            ])
                        ];
                    }),
                    _: 1
                }, 8, ["options", "selected", "class"])
            ]));
        };
    }
}));

;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/SizeAndFrequency.vue?vue&type=script&setup=true&lang=ts
 
;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/SizeAndFrequency.vue



const SizeAndFrequency_exports_ = SizeAndFrequencyvue_type_script_setup_true_lang_ts;

/* harmony default export */ const SizeAndFrequency = (SizeAndFrequency_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[8].use[0]!./src/js/vue/buyBoxV2/PaymentOptionRow.vue?vue&type=script&setup=true&lang=ts


var PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_1 = {
    class: "flex gap-8 justify-center items-center self-stretch w-full",
    role: "article"
};
var PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_2 = { class: "flex flex-1 shrink gap-1 items-start self-stretch my-auto w-full basis-0" };
var PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_3 = { class: "flex flex-1 shrink gap-3 items-start basis-0" };
var PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_4 = { class: "flex flex-col w-5" };
var PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_5 = {
    class: "flex flex-col justify-center items-center px-0.5 w-5 h-5 bg-white rounded-full border border-solid border-zinc-900",
    role: "presentation"
};
var PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_6 = { class: "flex flex-col flex-1 shrink basis-0" };
var PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_7 = { class: "flex gap-[8px] items-start self-start" };
var PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_8 = {
    class: "text-base font-bold leading-none text-zinc-900 text-left",
    role: "heading",
    "aria-level": "2"
};
var PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_9 = {
    key: 0,
    class: "gap-2.5 px-2 py-1 text-xs leading-none bg-orange-200 rounded text-zinc-900 whitespace-nowrap",
    role: "status",
    "aria-label": "Free bag offer"
};
var PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_10 = {
    class: "mt-2 text-xs leading-none text-neutral-600 text-left",
    role: "text"
};
var PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_11 = { key: 0 };
var PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_12 = { key: 1 };
var PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_13 = { class: "flex flex-col justify-center items-end text-right whitespace-nowrap" };
var _hoisted_14 = {
    class: "text-base font-bold leading-none text-black",
    role: "text",
    "aria-label": "Current price"
};
var _hoisted_15 = {
    key: 0,
    class: "mt-1 text-xs leading-none text-neutral-600 line-through",
    role: "text",
    "aria-label": "Original price"
};
/* harmony default export */ const PaymentOptionRowvue_type_script_setup_true_lang_ts = ((0,vue_cjs.defineComponent)({
    __name: 'PaymentOptionRow',
    props: {
        option: {}
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_1, [
                (0,vue_cjs.createElementVNode)("div", PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_2, [
                    (0,vue_cjs.createElementVNode)("div", PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_3, [
                        (0,vue_cjs.createElementVNode)("div", PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_4, [
                            (0,vue_cjs.createElementVNode)("div", PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_5, [
                                (0,vue_cjs.createElementVNode)("div", {
                                    class: (0,vue_cjs.normalizeClass)(["flex shrink-0 w-3 h-3 bg-red-500 rounded-full", {
                                            ' bg-red-500': _ctx.option.selected,
                                            'bg-white': !_ctx.option.selected,
                                        }]),
                                    role: "presentation"
                                }, null, 2)
                            ])
                        ]),
                        (0,vue_cjs.createElementVNode)("div", PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_6, [
                            (0,vue_cjs.createElementVNode)("div", PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_7, [
                                (0,vue_cjs.createElementVNode)("div", PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_8, (0,vue_cjs.toDisplayString)(_ctx.option.name), 1),
                                (_ctx.option.badge)
                                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_9, (0,vue_cjs.toDisplayString)(_ctx.option.badge), 1))
                                    : (0,vue_cjs.createCommentVNode)("", true)
                            ]),
                            (0,vue_cjs.createElementVNode)("div", PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_10, [
                                (_ctx.option.hasFreeShipping)
                                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_11, "Free Shipping"))
                                    : (_ctx.option.shippingCost)
                                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_12, " +" + (0,vue_cjs.toDisplayString)(_ctx.option.shippingCost) + " shipping ", 1))
                                        : (0,vue_cjs.createCommentVNode)("", true)
                            ])
                        ])
                    ]),
                    (0,vue_cjs.createElementVNode)("div", PaymentOptionRowvue_type_script_setup_true_lang_ts_hoisted_13, [
                        (0,vue_cjs.createElementVNode)("div", _hoisted_14, (0,vue_cjs.toDisplayString)(_ctx.option.initialDiscountedSubtotal), 1),
                        (_ctx.option.subtotal !== _ctx.option.initialDiscountedSubtotal)
                            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", _hoisted_15, (0,vue_cjs.toDisplayString)(_ctx.option.subtotal), 1))
                            : (0,vue_cjs.createCommentVNode)("", true)
                    ])
                ])
            ]));
        };
    }
}));

;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/PaymentOptionRow.vue?vue&type=script&setup=true&lang=ts
 
;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/PaymentOptionRow.vue



const PaymentOptionRow_exports_ = PaymentOptionRowvue_type_script_setup_true_lang_ts;

/* harmony default export */ const PaymentOptionRow = (PaymentOptionRow_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[8].use[0]!./src/js/vue/buyBoxV2/PaymentOptionColumn.vue?vue&type=script&setup=true&lang=ts


var PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_1 = { class: "my-auto flex w-full flex-col flex-1 self-stretch basis-0" };
var PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_2 = { class: "flex w-full items-start gap-3" };
var PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_3 = { class: "flex w-full flex-col flex-1 shrink basis-0 items-center" };
var PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_4 = {
    key: 0,
    class: "absolute top-[-12px] flex items-center gap-2.5 rounded bg-orange-200 px-2 py-1 text-xs leading-none text-zinc-900 min-h-[24px]",
    role: "status"
};
var PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_5 = { class: "font-bold text-zinc-900" };
var PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_6 = { class: "mt-1 flex items-center justify-center gap-1 text-right" };
var PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_7 = {
    key: 0,
    class: "text-sm leading-none text-neutral-600 line-through"
};
var PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_8 = { class: "mt-1 self-stretch text-center text-xs leading-none text-neutral-600" };
var PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_9 = { key: 0 };
var PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_10 = { key: 1 };
/* harmony default export */ const PaymentOptionColumnvue_type_script_setup_true_lang_ts = ((0,vue_cjs.defineComponent)({
    __name: 'PaymentOptionColumn',
    props: {
        option: {}
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_1, [
                (0,vue_cjs.createElementVNode)("div", PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_2, [
                    (0,vue_cjs.createElementVNode)("div", PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_3, [
                        (_ctx.option.badge)
                            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_4, (0,vue_cjs.toDisplayString)(_ctx.option.badge), 1))
                            : (0,vue_cjs.createCommentVNode)("", true),
                        (0,vue_cjs.createElementVNode)("div", PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_5, (0,vue_cjs.toDisplayString)(_ctx.option.name), 1),
                        (0,vue_cjs.createElementVNode)("div", PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_6, [
                            (_ctx.option.subtotal !== _ctx.option.initialDiscountedSubtotal)
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_7, (0,vue_cjs.toDisplayString)(_ctx.option.subtotal), 1))
                                : (0,vue_cjs.createCommentVNode)("", true),
                            (0,vue_cjs.createElementVNode)("div", {
                                class: (0,vue_cjs.normalizeClass)(["my-auto text-base leading-none", {
                                        'font-bold text-red-500': _ctx.option.subtotal !== _ctx.option.initialDiscountedSubtotal,
                                        'text-neutral-600': _ctx.option.subtotal === _ctx.option.initialDiscountedSubtotal,
                                    }])
                            }, (0,vue_cjs.toDisplayString)(_ctx.option.initialDiscountedSubtotal), 3)
                        ]),
                        (0,vue_cjs.createElementVNode)("div", PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_8, [
                            (_ctx.option.hasFreeShipping)
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_9, "Free Shipping"))
                                : (_ctx.option.shippingCost)
                                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", PaymentOptionColumnvue_type_script_setup_true_lang_ts_hoisted_10, " +" + (0,vue_cjs.toDisplayString)(_ctx.option.shippingCost) + " shipping ", 1))
                                    : (0,vue_cjs.createCommentVNode)("", true)
                        ])
                    ])
                ])
            ]));
        };
    }
}));

;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/PaymentOptionColumn.vue?vue&type=script&setup=true&lang=ts
 
;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/PaymentOptionColumn.vue



const PaymentOptionColumn_exports_ = PaymentOptionColumnvue_type_script_setup_true_lang_ts;

/* harmony default export */ const PaymentOptionColumn = (PaymentOptionColumn_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[8].use[0]!./src/js/vue/buyBoxV2/PaymentOption.vue?vue&type=script&setup=true&lang=ts


var PaymentOptionvue_type_script_setup_true_lang_ts_hoisted_1 = (0,vue_cjs.createElementVNode)("h2", { class: "self-stretch text-base font-bold leading-none text-zinc-900" }, " Payment Options ", -1);
var PaymentOptionvue_type_script_setup_true_lang_ts_hoisted_2 = ["aria-checked", "onClick"];



/* harmony default export */ const PaymentOptionvue_type_script_setup_true_lang_ts = ((0,vue_cjs.defineComponent)({
    __name: 'PaymentOption',
    props: {
        paymentOptions: {},
        tier: {},
        selectedBagSize: {},
        paymentOptionsLayout: {}
    },
    setup: function (__props) {
        var props = __props;
        var paymentOptionsLayout = props.paymentOptionsLayout;
        var _a = (0,vue_cjs.toRefs)(props), paymentOptions = _a.paymentOptions, tier = _a.tier, selectedBagSize = _a.selectedBagSize;
        var filteredPaymentOptions = (0,vue_cjs.computed)(function () {
            return paymentOptions.value.filter(function (option) {
                var _a, _b;
                return option.bagSize === ((_a = selectedBagSize.value) === null || _a === void 0 ? void 0 : _a.size) &&
                    option.tier === tier.value &&
                    option.quantity === ((_b = selectedBagSize.value) === null || _b === void 0 ? void 0 : _b.quantity);
            });
        });
        var selectOption = function (payment) {
            paymentOptions.value.forEach(function (option) {
                option.selected =
                    option.id === payment.id && option.quantity === payment.quantity;
            });
        };
        return function (_ctx, _cache) {
            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", {
                class: (0,vue_cjs.normalizeClass)(["flex w-full flex-col items-start max-md:max-w-full", { hidden: (0,vue_cjs.unref)(paymentOptionsLayout).hidePaymentOptions }]),
                role: "radiogroup",
                "aria-label": "Payment options"
            }, [
                PaymentOptionvue_type_script_setup_true_lang_ts_hoisted_1,
                (0,vue_cjs.createElementVNode)("div", {
                    class: (0,vue_cjs.normalizeClass)(["z-0 mt-2.5 w-full items-stretch grid gap-2 max-md:max-w-full", {
                            'grid-cols-3': (0,vue_cjs.unref)(paymentOptionsLayout).desktop === 'column',
                            'grid-cols-1': (0,vue_cjs.unref)(paymentOptionsLayout).desktop === 'row',
                            'max-md:grid-cols-1': (0,vue_cjs.unref)(paymentOptionsLayout).mobile === 'row',
                            'max-md:grid-cols-3': (0,vue_cjs.unref)(paymentOptionsLayout).mobile === 'column',
                        }])
                }, [
                    ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)(filteredPaymentOptions.value, function (option) {
                        return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("button", {
                            "aria-checked": option.selected,
                            key: option.id,
                            class: (0,vue_cjs.normalizeClass)([[
                                    option.selected
                                        ? 'bg-gray-100 border-zinc-900'
                                        : 'bg-white border-neutral-200',
                                ], "flex flex-1 items-center justify-center gap-8 rounded-lg border border-solid px-3 py-4 basis-0 relative hover:border-zinc-900"]),
                            role: "radio",
                            onClick: function ($event) { return (selectOption(option)); }
                        }, [
                            ((0,vue_cjs.unref)(paymentOptionsLayout).desktop === 'column')
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(PaymentOptionColumn, {
                                    key: 0,
                                    option: option,
                                    class: "max-md:hidden"
                                }, null, 8, ["option"]))
                                : (0,vue_cjs.createCommentVNode)("", true),
                            ((0,vue_cjs.unref)(paymentOptionsLayout).desktop === 'row')
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(PaymentOptionRow, {
                                    key: 1,
                                    option: option,
                                    class: "max-md:hidden"
                                }, null, 8, ["option"]))
                                : (0,vue_cjs.createCommentVNode)("", true),
                            ((0,vue_cjs.unref)(paymentOptionsLayout).mobile === 'column')
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(PaymentOptionColumn, {
                                    key: 2,
                                    option: option,
                                    class: "md:hidden max-md:block"
                                }, null, 8, ["option"]))
                                : (0,vue_cjs.createCommentVNode)("", true),
                            ((0,vue_cjs.unref)(paymentOptionsLayout).mobile === 'row')
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(PaymentOptionRow, {
                                    key: 3,
                                    option: option,
                                    class: "md:hidden max-md:block"
                                }, null, 8, ["option"]))
                                : (0,vue_cjs.createCommentVNode)("", true)
                        ], 10, PaymentOptionvue_type_script_setup_true_lang_ts_hoisted_2));
                    }), 128))
                ], 2)
            ], 2));
        };
    }
}));

;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/PaymentOption.vue?vue&type=script&setup=true&lang=ts
 
;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/PaymentOption.vue



const PaymentOption_exports_ = PaymentOptionvue_type_script_setup_true_lang_ts;

/* harmony default export */ const PaymentOption = (PaymentOption_exports_);
// EXTERNAL MODULE: ./src/js/utils/api/recommendations.ts
var recommendations = __webpack_require__(2287);
// EXTERNAL MODULE: ./src/js/vue/cart/api.js
var api = __webpack_require__(8425);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[8].use[0]!./src/js/vue/buyBoxV2/BuyBoxUpsell.vue?vue&type=script&setup=true&lang=ts
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_1 = { class: "py-6 bg-transparent rounded-lg text-[#1a1a1a]" };
var BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_2 = {
    key: 0,
    class: "text-xl font-bold mb-4"
};
var BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_3 = { class: "space-y-4" };
var BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_4 = ["href"];
var BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_5 = ["src", "alt"];
var BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_6 = { class: "flex flex-col md:flex-row items-start w-full" };
var BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_7 = { class: "flex-1 text-left" };
var BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_8 = { class: "text-sm text-gray-500 mb-2" };
var BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_9 = { class: "text-lg leading-none font-bold" };
var BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_10 = ["href"];
var BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_11 = {
    key: 0,
    class: "text-[#f53c32] text-xs font-bold hidden md:block mt-2"
};
var BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_12 = { class: "flex flex-col items-start md:items-end" };
var BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_13 = { class: "my-2 text-base font-bold" };
var BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_14 = {
    key: 0,
    class: "font-normal line-through"
};
var BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_15 = { class: "ml-2" };
var _hoisted_16 = {
    key: 1,
    class: "text-[#f53c32] ml-2 text-xs font-bold inline md:hidden"
};
var _hoisted_17 = ["onClick"];
var _hoisted_18 = (0,vue_cjs.createElementVNode)("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, [
    (0,vue_cjs.createElementVNode)("path", {
        d: "M1 8.00617L5.43333 12.3333L15 3",
        stroke: "black",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })
], -1);
var _hoisted_19 = (0,vue_cjs.createElementVNode)("span", { class: "ml-2" }, "Added", -1);
var _hoisted_20 = [
    _hoisted_18,
    _hoisted_19
];
var _hoisted_21 = ["onClick"];


/* harmony default export */ const BuyBoxUpsellvue_type_script_setup_true_lang_ts = ((0,vue_cjs.defineComponent)({
    __name: 'BuyBoxUpsell',
    props: {
        productList: {},
        title: {},
        addOnDiscounts: {}
    },
    setup: function (__props) {
        var _this = this;
        var props = __props;
        var productList = props.productList, title = props.title, addOnDiscounts = props.addOnDiscounts;
        var cart = (0,vue_cjs.ref)({});
        var messages = (0,vue_cjs.ref)([]);
        var fetchCart = function () { return __awaiter(_this, void 0, void 0, function () {
            var cartData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, api/* default */.A.fetch()];
                    case 1:
                        cartData = _a.sent();
                        cart.value = __assign({}, cartData);
                        return [2];
                }
            });
        }); };
        fetchCart();
        var cartItems = (0,vue_cjs.computed)(function () {
            var _a, _b;
            return ((_b = (_a = cart.value) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.map(function (item) { return item.product_id; })) || [];
        });
        var parseAddOnDiscounts = function (addOnDiscounts, productId, productPrice) {
            var discountedPrice = productPrice;
            var productGID = "gid://shopify/Product/".concat(productId);
            addOnDiscounts.forEach(function (discount) {
                var _a, _b, _c, _d;
                var customerGets = discount.customerGets;
                var discountEffect = (_b = (_a = customerGets === null || customerGets === void 0 ? void 0 : customerGets.value) === null || _a === void 0 ? void 0 : _a.discountOnQuantity) === null || _b === void 0 ? void 0 : _b.effect;
                var eligibleProducts = ((_d = (_c = customerGets === null || customerGets === void 0 ? void 0 : customerGets.items) === null || _c === void 0 ? void 0 : _c.products) === null || _d === void 0 ? void 0 : _d.productsToAdd) || [];
                var message = discount.message;
                if (eligibleProducts.includes(productId) ||
                    eligibleProducts.includes(productGID)) {
                    if (discountEffect === null || discountEffect === void 0 ? void 0 : discountEffect.percentage) {
                        discountedPrice *= 1 - discountEffect.percentage;
                    }
                    if (!messages.value.some(function (msg) { return msg.productId === productId; })) {
                        messages.value.push({ productId: productId, message: message });
                    }
                }
            });
            return discountedPrice.toFixed(2);
        };
        var getDiscountedPrice = function (product) {
            var productId = product.id;
            var productPrice = product.price / 100;
            return parseAddOnDiscounts(addOnDiscounts, String(productId), productPrice);
        };
        window.addEventListener('cartUpdate', function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, fetchCart()];
                            case 1:
                                _a.sent();
                                return [2];
                        }
                    });
                }); }, 500);
                return [2];
            });
        }); });
        var handleAddToCart = function (product) { return __awaiter(_this, void 0, void 0, function () {
            var variantId, event;
            return __generator(this, function (_a) {
                variantId = product.variants[0].id;
                window['Additem']({
                    id: variantId,
                    quantity: 1,
                });
                window['openCart']();
                event = new CustomEvent('cartUpdate', {
                    detail: {
                        id: variantId,
                        quantity: 1,
                    },
                });
                window.dispatchEvent(event);
                return [2];
            });
        }); };
        var handleRemoveFromCart = function (product, cartIndex) { return __awaiter(_this, void 0, void 0, function () {
            var variantId, cartRemoveEvent, event;
            return __generator(this, function (_a) {
                variantId = product.variants[0].id;
                cartRemoveEvent = new CustomEvent('cartItemRemove', {
                    detail: {
                        line: cartIndex + 1,
                    },
                });
                window.dispatchEvent(cartRemoveEvent);
                window['openCart']();
                event = new CustomEvent('cartUpdate', {
                    detail: {
                        id: variantId,
                        quantity: 0,
                    },
                });
                window.dispatchEvent(event);
                return [2];
            });
        }); };
        return function (_ctx, _cache) {
            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_1, [
                ((0,vue_cjs.unref)(title))
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("h2", BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_2, (0,vue_cjs.toDisplayString)((0,vue_cjs.unref)(title)), 1))
                    : (0,vue_cjs.createCommentVNode)("", true),
                (0,vue_cjs.createElementVNode)("div", BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_3, [
                    ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)((0,vue_cjs.unref)(productList), function (_a) {
                        var _b, _c;
                        var product = _a.product, brand_name = _a.brand_name;
                        return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", {
                            key: product.id,
                            class: "flex p-4 bg-[#f6f6f6]"
                        }, [
                            (0,vue_cjs.createElementVNode)("a", {
                                href: "/products/".concat(product.handle)
                            }, [
                                (0,vue_cjs.createElementVNode)("img", {
                                    src: product.featured_image,
                                    alt: product.title,
                                    class: "w-16 h-16 object-cover rounded-md mr-4"
                                }, null, 8, BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_5)
                            ], 8, BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_4),
                            (0,vue_cjs.createElementVNode)("section", BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_6, [
                                (0,vue_cjs.createElementVNode)("div", BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_7, [
                                    (0,vue_cjs.createElementVNode)("div", BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_8, (0,vue_cjs.toDisplayString)(brand_name), 1),
                                    (0,vue_cjs.createElementVNode)("h3", BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_9, [
                                        (0,vue_cjs.createElementVNode)("a", {
                                            href: "/products/".concat(product.handle)
                                        }, (0,vue_cjs.toDisplayString)(product.title), 9, BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_10)
                                    ]),
                                    (messages.value.some(function (msg) { return msg.productId === String(product.id); }))
                                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_11, (0,vue_cjs.toDisplayString)((_b = messages.value.find(function (msg) { return msg.productId === String(product.id); })) === null || _b === void 0 ? void 0 : _b.message), 1))
                                        : (0,vue_cjs.createCommentVNode)("", true)
                                ]),
                                (0,vue_cjs.createElementVNode)("div", BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_12, [
                                    (0,vue_cjs.createElementVNode)("div", BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_13, [
                                        (String(product.price) !== getDiscountedPrice(product))
                                            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_14, " $" + (0,vue_cjs.toDisplayString)((product.price / 100).toFixed(2)), 1))
                                            : (0,vue_cjs.createCommentVNode)("", true),
                                        (0,vue_cjs.createElementVNode)("span", BuyBoxUpsellvue_type_script_setup_true_lang_ts_hoisted_15, "$" + (0,vue_cjs.toDisplayString)(getDiscountedPrice(product)), 1),
                                        (messages.value.some(function (msg) { return msg.productId === String(product.id); }))
                                            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", _hoisted_16, (0,vue_cjs.toDisplayString)((_c = messages.value.find(function (msg) { return msg.productId === String(product.id); })) === null || _c === void 0 ? void 0 : _c.message), 1))
                                            : (0,vue_cjs.createCommentVNode)("", true)
                                    ]),
                                    (cart.value && cartItems.value.includes(product.id))
                                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("button", {
                                            key: 0,
                                            onClick: function ($event) { return (handleRemoveFromCart(product, cartItems.value.indexOf(product.id))); },
                                            class: "md:ml-4 px-12 py-2 border-[2px] border-solid border-[#1A1A1A] text-[#1A1A1A] bg-transparent rounded font-bold flex justify-center items-center"
                                        }, _hoisted_20, 8, _hoisted_17))
                                        : ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("button", {
                                            key: 1,
                                            class: "md:ml-4 px-12 py-2 bg-[#1A1A1A] text-white hover:bg-[#4D4D4D] rounded font-bold border-[2px] border-solid border-[#1A1A1A] hover:border-[#4D4D4D]",
                                            onClick: function ($event) { return (handleAddToCart(product)); }
                                        }, " Add ", 8, _hoisted_21))
                                ])
                            ])
                        ]));
                    }), 128))
                ])
            ]));
        };
    }
}));

;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/BuyBoxUpsell.vue?vue&type=script&setup=true&lang=ts
 
;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/BuyBoxUpsell.vue



const BuyBoxUpsell_exports_ = BuyBoxUpsellvue_type_script_setup_true_lang_ts;

/* harmony default export */ const BuyBoxUpsell = (BuyBoxUpsell_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[8].use[0]!./src/js/vue/buyBoxV2/AddToCart.vue?vue&type=script&setup=true&lang=ts
var AddToCartvue_type_script_setup_true_lang_ts_assign = (undefined && undefined.__assign) || function () {
    AddToCartvue_type_script_setup_true_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return AddToCartvue_type_script_setup_true_lang_ts_assign.apply(this, arguments);
};
var AddToCartvue_type_script_setup_true_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var AddToCartvue_type_script_setup_true_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var AddToCartvue_type_script_setup_true_lang_ts_hoisted_1 = {
    key: 0,
    class: "py-6 text-zinc-900 text-left"
};
var AddToCartvue_type_script_setup_true_lang_ts_hoisted_2 = { class: "flex justify-between mb-2" };
var AddToCartvue_type_script_setup_true_lang_ts_hoisted_3 = {
    key: 0,
    class: "flex justify-between mb-2"
};
var AddToCartvue_type_script_setup_true_lang_ts_hoisted_4 = { class: "line-through items-end font-normal mr-2" };
var AddToCartvue_type_script_setup_true_lang_ts_hoisted_5 = (0,vue_cjs.createElementVNode)("span", { class: "" }, "FREE", -1);
var AddToCartvue_type_script_setup_true_lang_ts_hoisted_6 = (0,vue_cjs.createElementVNode)("div", { class: "flex justify-between mb-2" }, [
    (0,vue_cjs.createElementVNode)("span", null, "Shipping"),
    (0,vue_cjs.createElementVNode)("span", null, [
        (0,vue_cjs.createElementVNode)("span", { class: "line-through items-end font-normal mr-2" }, "-$1.75"),
        (0,vue_cjs.createElementVNode)("span", { class: "items-end" }, "FREE")
    ])
], -1);
var AddToCartvue_type_script_setup_true_lang_ts_hoisted_7 = { class: "flex justify-between font-bold text-lg" };
var AddToCartvue_type_script_setup_true_lang_ts_hoisted_8 = (0,vue_cjs.createElementVNode)("span", null, "Total", -1);
var AddToCartvue_type_script_setup_true_lang_ts_hoisted_9 = { class: "flex w-full items-start justify-center gap-4 text-lg font-bold leading-none text-white max-md:max-w-full" };
var AddToCartvue_type_script_setup_true_lang_ts_hoisted_10 = {
    key: 0,
    class: "inline"
};
var AddToCartvue_type_script_setup_true_lang_ts_hoisted_11 = {
    key: 0,
    class: "inline"
};
var AddToCartvue_type_script_setup_true_lang_ts_hoisted_12 = { class: "text-[#ececec] line-through font-normal inline" };
var AddToCartvue_type_script_setup_true_lang_ts_hoisted_13 = { class: "flex justify-center max-md:flex-col max-md:items-center gap-[16px] mt-4 max-md:gap-[8px]" };
var AddToCartvue_type_script_setup_true_lang_ts_hoisted_14 = { class: "my-auto flex items-center self-stretch gap-1" };
var AddToCartvue_type_script_setup_true_lang_ts_hoisted_15 = ["src", "alt"];
var AddToCartvue_type_script_setup_true_lang_ts_hoisted_16 = { class: "my-auto self-stretch" };





var redirectToCheckout = false;
/* harmony default export */ const AddToCartvue_type_script_setup_true_lang_ts = ((0,vue_cjs.defineComponent)({
    __name: 'AddToCart',
    props: {
        product: {},
        bulletPoints: {},
        checkoutSettings: {},
        grind: {},
        paymentPlan: {},
        planInterval: {},
        upsell: {}
    },
    setup: function (__props) {
        var _this = this;
        var props = __props;
        var checkoutSettings = props.checkoutSettings, bulletPoints = props.bulletPoints, upsell = props.upsell;
        var _a = (0,vue_cjs.toRefs)(props), paymentPlan = _a.paymentPlan, product = _a.product, grind = _a.grind, planInterval = _a.planInterval;
        var recommendation = (0,vue_cjs.ref)(null);
        var isHovered = (0,vue_cjs.ref)(false);
        var variant = (0,vue_cjs.computed)(function () {
            var _a;
            return (0,helpers/* getVariantForBagSize */.cS)(product.value.variants, (_a = paymentPlan.value) === null || _a === void 0 ? void 0 : _a.bagSize);
        });
        var isUpsellActive = (0,vue_cjs.computed)(function () {
            var _a;
            return Boolean(variant.value && ((_a = variant.value) === null || _a === void 0 ? void 0 : _a.title) === 'Big Bag' && upsell);
        });
        var upsellVariantId = (0,vue_cjs.computed)(function () {
            var _a, _b;
            return (_b = (_a = upsell === null || upsell === void 0 ? void 0 : upsell.productList[0]) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.variants[0].id;
        });
        var isDiscounted = (0,vue_cjs.computed)(function () {
            var _a, _b;
            return (JSON.stringify((_a = paymentPlan === null || paymentPlan === void 0 ? void 0 : paymentPlan.value) === null || _a === void 0 ? void 0 : _a.initialDiscountedSubtotal) !==
                JSON.stringify((_b = paymentPlan === null || paymentPlan === void 0 ? void 0 : paymentPlan.value) === null || _b === void 0 ? void 0 : _b.subtotal));
        });
        var getSellingPlan = (0,vue_cjs.computed)(function () {
            var _a;
            var plan = paymentPlan.value;
            var prod = product.value;
            var productVariant = variant.value;
            if (!plan || !prod || !productVariant) {
                console.warn('Missing required data to get selling plan', {
                    plan: plan,
                    prod: prod,
                    productVariant: productVariant,
                });
                return null;
            }
            switch (plan.sellingPlanPayment) {
                case 'pay-per-shipment':
                    return (_a = prod.sellingPlans
                        .find(function (p) { return p.name === plan.sellingPlanName; })) === null || _a === void 0 ? void 0 : _a.selling_plans.find(function (p) { var _a; return p.name.includes(String((_a = planInterval.value) === null || _a === void 0 ? void 0 : _a.interval)); });
                case 'prepay-3-bags':
                case 'prepay-6-bags':
                case 'prepay-12-bags': {
                    var sellingPlanForVariant = prod.sellingPlans.find(function (p) { return p.name === "Prepaid-".concat(productVariant.id); });
                    var bagsMatch = plan.sellingPlanPayment.match(/^prepay-(\d+)-bags$/);
                    var bags_1 = bagsMatch && bagsMatch[1];
                    return sellingPlanForVariant === null || sellingPlanForVariant === void 0 ? void 0 : sellingPlanForVariant.selling_plans.find(function (p) {
                        return p.options.some(function (option) { return option.value === "".concat(bags_1, " shipments"); });
                    });
                }
                default:
                    return null;
            }
        });
        var createProductProperties = (0,vue_cjs.computed)(function () {
            var _a;
            var _b;
            var plan = paymentPlan.value;
            var productVariant = variant.value;
            var grindType = grind.value;
            var sellingPlan = getSellingPlan.value;
            if (!plan || !productVariant || !grindType) {
                console.warn('Missing required data to create product properties', {
                    plan: plan,
                    productVariant: productVariant,
                    grindType: grindType,
                    sellingPlan: sellingPlan,
                });
                return null;
            }
            var productProperties = {
                id: productVariant.id,
                quantity: Number(plan.quantity),
                sku: productVariant.sku,
                properties: (_a = {},
                    _a['Grind Type'] = grindType.label,
                    _a._grind_type = grindType.handle,
                    _a._is_subscription = true,
                    _a),
                selling_plan: (sellingPlan === null || sellingPlan === void 0 ? void 0 : sellingPlan.id) ? String(sellingPlan.id) : undefined,
                toCheckout: redirectToCheckout,
            };
            if (plan.sellingPlanPayment === 'pay-per-shipment') {
                productProperties.properties._subscription_type = 'pay-as-go';
            }
            else if (plan.sellingPlanPayment === 'prepay-3-bags' ||
                plan.sellingPlanPayment === 'prepay-6-bags' ||
                plan.sellingPlanPayment === 'prepay-12-bags') {
                var bagsMatch = plan.sellingPlanPayment.match(/^prepay-(\d+)-bags$/);
                var prepaidBagCount = bagsMatch ? Number(bagsMatch[1]) : undefined;
                productProperties.properties._change_prepaid_frequency = "".concat((_b = planInterval.value) === null || _b === void 0 ? void 0 : _b.interval, ",1");
                productProperties.properties._subscription_type = 'prepaid';
                if (prepaidBagCount) {
                    productProperties.properties._no_of_prepaid_bags = prepaidBagCount;
                }
            }
            return productProperties;
        });
        var applyRecommendationData = function (productData) {
            var _a, _b;
            if (!((_a = recommendation.value) === null || _a === void 0 ? void 0 : _a.queue) || recommendation.value.queue.length === 0)
                return;
            var initialRecommendedProduct = recommendation.value.queue[0];
            var queue = recommendation.value.queue.slice(1, 4).map(function (p) { return ({
                shopifyProductId: p.shopifyProductId,
                shopifyVariantId: p.shopifyVariantId,
            }); });
            productData.properties = AddToCartvue_type_script_setup_true_lang_ts_assign(AddToCartvue_type_script_setup_true_lang_ts_assign({}, productData.properties), { _queue: JSON.stringify(queue), _bag_size: (_b = paymentPlan.value) === null || _b === void 0 ? void 0 : _b.bagSize, _change_shopify_product_id: initialRecommendedProduct.shopifyProductId, _change_shopify_variant_id: initialRecommendedProduct.shopifyVariantId, _taste_collectionId: recommendation.value.taste_collection_id });
        };
        var applyDiscountOverride = function (productData) {
            var _a, _b, _c, _d;
            if (((_a = paymentPlan.value) === null || _a === void 0 ? void 0 : _a.initialDiscountedSubtotalOverride) &&
                ((_b = paymentPlan.value) === null || _b === void 0 ? void 0 : _b.initialDiscountedSubtotalOverride) > 0 &&
                ((_c = paymentPlan.value) === null || _c === void 0 ? void 0 : _c.discountOverrideType) !== 'null') {
                productData.properties._discount_override_settings = JSON.stringify({
                    type: paymentPlan.value.discountOverrideType,
                    message: ((_d = paymentPlan.value) === null || _d === void 0 ? void 0 : _d.badge) || 'Welcome Offer',
                    amount: paymentPlan.value.initialDiscountedSubtotalOverride,
                });
            }
        };
        var handleAddToCart = function () { return AddToCartvue_type_script_setup_true_lang_ts_awaiter(_this, void 0, void 0, function () {
            var prodData, cart, sellingPlansAlreadyInCart, operation_1, cartUpdate;
            return AddToCartvue_type_script_setup_true_lang_ts_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        prodData = createProductProperties.value;
                        if (!prodData)
                            return [2];
                        if (!(getSellingPlan.value && recommendation.value)) return [3, 4];
                        return [4, api/* default */.A.fetch()];
                    case 1:
                        cart = _a.sent();
                        sellingPlansAlreadyInCart = cart.items.filter(function (cartItem) { return cartItem.selling_plan_allocation; });
                        if (!(sellingPlansAlreadyInCart.length > 0)) return [3, 3];
                        operation_1 = {};
                        sellingPlansAlreadyInCart.forEach(function (cartItem) {
                            operation_1[cartItem.id] = 0;
                        });
                        return [4, api/* default */.A.update(operation_1)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        applyRecommendationData(prodData);
                        _a.label = 4;
                    case 4:
                        applyDiscountOverride(prodData);
                        if (isUpsellActive.value) {
                            window['Additem']({
                                items: [{ id: upsellVariantId.value, quantity: 1 }, prodData],
                            });
                            cartUpdate = new CustomEvent('cartUpdate', {
                                detail: {
                                    id: upsellVariantId.value,
                                    quantity: 1,
                                },
                            });
                            window.dispatchEvent(cartUpdate);
                        }
                        else {
                            window['Additem'](prodData);
                        }
                        if (!redirectToCheckout) {
                            window['openCart']();
                        }
                        return [2];
                }
            });
        }); };
        var fetchRecommendations = function () { return AddToCartvue_type_script_setup_true_lang_ts_awaiter(_this, void 0, void 0, function () {
            var collectionId, _a;
            var _b;
            return AddToCartvue_type_script_setup_true_lang_ts_generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!paymentPlan.value || !product.value)
                            return [2];
                        collectionId = product.value.collectionId.replace('gid://shopify/Collection/', '');
                        _a = recommendation;
                        return [4, (0,recommendations/* getRecommendations */.Dz)({
                                collectionId: collectionId,
                                bagSize: (_b = paymentPlan.value) === null || _b === void 0 ? void 0 : _b.bagSize,
                            })];
                    case 1:
                        _a.value = _c.sent();
                        return [2];
                }
            });
        }); };
        var buttonStyles = (0,vue_cjs.computed)(function () { return ({
            backgroundColor: isHovered.value
                ? checkoutSettings.hoverBackgroundColor
                : checkoutSettings.backgroundColor,
        }); });
        (0,vue_cjs.watch)([product, paymentPlan], function () { return AddToCartvue_type_script_setup_true_lang_ts_awaiter(_this, void 0, void 0, function () {
            return AddToCartvue_type_script_setup_true_lang_ts_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetchRecommendations()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); });
        (0,vue_cjs.onMounted)(function () { return AddToCartvue_type_script_setup_true_lang_ts_awaiter(_this, void 0, void 0, function () {
            return AddToCartvue_type_script_setup_true_lang_ts_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetchRecommendations()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); });
        return function (_ctx, _cache) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("section", {
                class: (0,vue_cjs.normalizeClass)({
                    'flex flex-col text-center': true,
                    'fixed bottom-6 right-[5%] md:right-[7%] w-[90%] md:w-[58%] p-4': (_a = (0,vue_cjs.unref)(checkoutSettings)) === null || _a === void 0 ? void 0 : _a.isAddToCartFixed,
                    'w-full max-md:max-w-full': !((_b = (0,vue_cjs.unref)(checkoutSettings)) === null || _b === void 0 ? void 0 : _b.isAddToCartFixed),
                }),
                "aria-labelledby": "cart-section-title",
                style: (0,vue_cjs.normalizeStyle)(((_c = (0,vue_cjs.unref)(checkoutSettings)) === null || _c === void 0 ? void 0 : _c.isAddToCartFixed)
                    ? { backgroundColor: (0,vue_cjs.unref)(checkoutSettings).fixedBackgroundColor }
                    : {})
            }, [
                ((0,vue_cjs.unref)(checkoutSettings).showOrderSummary)
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", AddToCartvue_type_script_setup_true_lang_ts_hoisted_1, [
                        (0,vue_cjs.createElementVNode)("div", AddToCartvue_type_script_setup_true_lang_ts_hoisted_2, [
                            (0,vue_cjs.createElementVNode)("span", null, (0,vue_cjs.toDisplayString)((0,vue_cjs.unref)(product).title), 1),
                            (0,vue_cjs.createElementVNode)("span", null, (0,vue_cjs.toDisplayString)((_d = (0,vue_cjs.unref)(paymentPlan)) === null || _d === void 0 ? void 0 : _d.initialDiscountedSubtotal), 1)
                        ]),
                        (variant.value && ((_e = variant.value) === null || _e === void 0 ? void 0 : _e.title) === 'Big Bag')
                            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", AddToCartvue_type_script_setup_true_lang_ts_hoisted_3, [
                                (0,vue_cjs.createElementVNode)("span", null, (0,vue_cjs.toDisplayString)((_h = (_g = (_f = (0,vue_cjs.unref)(upsell)) === null || _f === void 0 ? void 0 : _f.productList[0]) === null || _g === void 0 ? void 0 : _g.product) === null || _h === void 0 ? void 0 : _h.title), 1),
                                (0,vue_cjs.createElementVNode)("span", null, [
                                    (0,vue_cjs.createElementVNode)("span", AddToCartvue_type_script_setup_true_lang_ts_hoisted_4, " -$" + (0,vue_cjs.toDisplayString)((((_m = (_l = (_k = (_j = (0,vue_cjs.unref)(upsell)) === null || _j === void 0 ? void 0 : _j.productList[0]) === null || _k === void 0 ? void 0 : _k.product) === null || _l === void 0 ? void 0 : _l.price) !== null && _m !== void 0 ? _m : 0) / 100).toFixed(2)), 1),
                                    AddToCartvue_type_script_setup_true_lang_ts_hoisted_5
                                ])
                            ]))
                            : (0,vue_cjs.createCommentVNode)("", true),
                        AddToCartvue_type_script_setup_true_lang_ts_hoisted_6,
                        (0,vue_cjs.createElementVNode)("div", AddToCartvue_type_script_setup_true_lang_ts_hoisted_7, [
                            AddToCartvue_type_script_setup_true_lang_ts_hoisted_8,
                            (0,vue_cjs.createElementVNode)("span", null, (0,vue_cjs.toDisplayString)((_o = (0,vue_cjs.unref)(paymentPlan)) === null || _o === void 0 ? void 0 : _o.initialDiscountedSubtotal), 1)
                        ])
                    ]))
                    : (0,vue_cjs.createCommentVNode)("", true),
                (0,vue_cjs.createElementVNode)("div", AddToCartvue_type_script_setup_true_lang_ts_hoisted_9, [
                    (0,vue_cjs.createElementVNode)("button", {
                        onClick: handleAddToCart,
                        class: "min-h-[48px] min-w-[240px] w-full flex-1 shrink rounded px-10 py-3.5 self-stretch gap-2 max-md:px-5 max-md:max-w-full",
                        "aria-label": "Add to Cart",
                        disabled: false,
                        style: (0,vue_cjs.normalizeStyle)(buttonStyles.value),
                        onMouseover: _cache[0] || (_cache[0] = function ($event) { return (isHovered.value = true); }),
                        onMouseleave: _cache[1] || (_cache[1] = function ($event) { return (isHovered.value = false); })
                    }, [
                        (0,vue_cjs.createTextVNode)((0,vue_cjs.toDisplayString)((0,vue_cjs.unref)(checkoutSettings).addToCartText) + " ", 1),
                        ((_p = (0,vue_cjs.unref)(checkoutSettings)) === null || _p === void 0 ? void 0 : _p.isCtaPriceVisible)
                            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", AddToCartvue_type_script_setup_true_lang_ts_hoisted_10, [
                                (isDiscounted.value)
                                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", AddToCartvue_type_script_setup_true_lang_ts_hoisted_11, [
                                        (0,vue_cjs.createTextVNode)(" - "),
                                        (0,vue_cjs.createElementVNode)("span", AddToCartvue_type_script_setup_true_lang_ts_hoisted_12, (0,vue_cjs.toDisplayString)((_q = (0,vue_cjs.unref)(paymentPlan)) === null || _q === void 0 ? void 0 : _q.subtotal), 1)
                                    ]))
                                    : (0,vue_cjs.createCommentVNode)("", true),
                                (0,vue_cjs.createTextVNode)(" " + (0,vue_cjs.toDisplayString)((_r = (0,vue_cjs.unref)(paymentPlan)) === null || _r === void 0 ? void 0 : _r.initialDiscountedSubtotal), 1)
                            ]))
                            : (0,vue_cjs.createCommentVNode)("", true)
                    ], 36)
                ]),
                (0,vue_cjs.createElementVNode)("div", AddToCartvue_type_script_setup_true_lang_ts_hoisted_13, [
                    ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)((0,vue_cjs.unref)(bulletPoints), function (item) {
                        return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", {
                            key: item.text,
                            class: "flex gap-4 text-sm leading-none text-zinc-900"
                        }, [
                            (0,vue_cjs.createElementVNode)("div", AddToCartvue_type_script_setup_true_lang_ts_hoisted_14, [
                                (0,vue_cjs.createElementVNode)("img", {
                                    loading: "lazy",
                                    src: item.icon,
                                    alt: "".concat(item.icon, " Icon"),
                                    class: "my-auto aspect-square w-6 shrink-0 object-contain self-stretch"
                                }, null, 8, AddToCartvue_type_script_setup_true_lang_ts_hoisted_15),
                                (0,vue_cjs.createElementVNode)("span", AddToCartvue_type_script_setup_true_lang_ts_hoisted_16, (0,vue_cjs.toDisplayString)(item.text), 1)
                            ])
                        ]));
                    }), 128))
                ]),
                (isUpsellActive.value)
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(BuyBoxUpsell, {
                        key: 1,
                        "is-upsell-active": isUpsellActive.value,
                        "product-list": (_s = (0,vue_cjs.unref)(upsell)) === null || _s === void 0 ? void 0 : _s.productList,
                        "add-on-discounts": (_t = (0,vue_cjs.unref)(upsell)) === null || _t === void 0 ? void 0 : _t.addOnDiscounts
                    }, null, 8, ["is-upsell-active", "product-list", "add-on-discounts"]))
                    : (0,vue_cjs.createCommentVNode)("", true)
            ], 6));
        };
    }
}));

;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/AddToCart.vue?vue&type=script&setup=true&lang=ts
 
;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/AddToCart.vue



const AddToCart_exports_ = AddToCartvue_type_script_setup_true_lang_ts;

/* harmony default export */ const AddToCart = (AddToCart_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[8].use[0]!./src/js/vue/buyBoxV2/BuyBoxV2Image.vue?vue&type=script&setup=true&lang=ts


var BuyBoxV2Imagevue_type_script_setup_true_lang_ts_hoisted_1 = ["src", "alt"];
/* harmony default export */ const BuyBoxV2Imagevue_type_script_setup_true_lang_ts = ((0,vue_cjs.defineComponent)({
    __name: 'BuyBoxV2Image',
    props: {
        imageUrl: {},
        imageAlt: {}
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("img", {
                src: _ctx.imageUrl,
                alt: _ctx.imageAlt,
                loading: "lazy",
                class: "object-contain flex-1 w-full rounded-lg max-h-lg h-auto"
            }, null, 8, BuyBoxV2Imagevue_type_script_setup_true_lang_ts_hoisted_1));
        };
    }
}));

;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/BuyBoxV2Image.vue?vue&type=script&setup=true&lang=ts
 
;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/BuyBoxV2Image.vue



const BuyBoxV2Image_exports_ = BuyBoxV2Imagevue_type_script_setup_true_lang_ts;

/* harmony default export */ const BuyBoxV2Image = (BuyBoxV2Image_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[8].use[0]!./src/js/vue/buyBoxV2/BuyBoxV2Container.vue?vue&type=script&setup=true&lang=ts


var BuyBoxV2Containervue_type_script_setup_true_lang_ts_hoisted_1 = { class: "mx-auto flex max-w-[1920px] flex-row gap-5 max-md:flex-col md:justify-between" };
var BuyBoxV2Containervue_type_script_setup_true_lang_ts_hoisted_2 = {
    key: 0,
    class: "swiper-container buy-box-v2-carousel relative"
};
var BuyBoxV2Containervue_type_script_setup_true_lang_ts_hoisted_3 = { class: "swiper-wrapper" };
var BuyBoxV2Containervue_type_script_setup_true_lang_ts_hoisted_4 = (0,vue_cjs.createElementVNode)("div", { class: "relative" }, [
    (0,vue_cjs.createElementVNode)("div", { class: "swiper-pagination" })
], -1);
var BuyBoxV2Containervue_type_script_setup_true_lang_ts_hoisted_5 = { key: 1 };








/* harmony default export */ const BuyBoxV2Containervue_type_script_setup_true_lang_ts = ((0,vue_cjs.defineComponent)({
    __name: 'BuyBoxV2Container',
    props: {
        product: {},
        productsList: {},
        grindTypeOptions: {},
        bagSizeOptions: {},
        planIntervalOptions: {},
        paymentOptions: {},
        bulletPoints: {},
        positions: {},
        checkoutSettings: {},
        recommendation: {},
        tooltip: {},
        paymentOptionsLayout: {},
        backgroundColor: {},
        upsell: {},
        showImageCarousel: {}
    },
    setup: function (__props) {
        var props = __props;
        var product = (0,vue_cjs.ref)(props.product);
        var productsList = (0,vue_cjs.reactive)(props.productsList);
        var grindTypeOptions = (0,vue_cjs.reactive)(props.grindTypeOptions);
        var planIntervalOptions = (0,vue_cjs.reactive)(props.planIntervalOptions);
        var bagSizeOptions = (0,vue_cjs.reactive)(props.bagSizeOptions);
        var paymentOptions = (0,vue_cjs.reactive)(props.paymentOptions);
        var backgroundColor = (0,vue_cjs.ref)(props.backgroundColor);
        var updateProduct = function (newProduct) {
            product.value = newProduct;
        };
        var _a = props.checkoutSettings, isAddToCartFixed = _a.isAddToCartFixed, showGrindButtons = _a.showGrindButtons, showOrderSummary = _a.showOrderSummary;
        var createComponentConfig = function (component, props, emits, position) { return ({
            component: component,
            props: props,
            emits: emits,
            position: position,
        }); };
        var components = (0,vue_cjs.computed)(function () { return ({
            Description: createComponentConfig(BuyBoxV2Description, { product: product.value }, {}, props.positions.description),
            Flavor: createComponentConfig(BuyBoxV2Flavor, {
                productsList: productsList,
                paymentOptions: paymentOptions,
                product: product.value,
                tooltip: props.tooltip,
                recommendation: props.recommendation,
            }, { 'update:product': updateProduct }, props.positions.flavor),
            GrindType: createComponentConfig(BuyBoxV2Grind, { grindTypeOptions: grindTypeOptions, showGrindButtons: showGrindButtons }, {}, props.positions.grindType),
            SizeAndFrequency: createComponentConfig(SizeAndFrequency, {
                planIntervalOptions: planIntervalOptions,
                bagSizeOptions: bagSizeOptions,
                paymentOptions: paymentOptions,
                product: product.value,
            }, {}, props.positions.sizeAndFrequency),
            PaymentOptions: createComponentConfig(PaymentOption, {
                paymentOptions: paymentOptions,
                tier: product.value.tier,
                selectedBagSize: bagSizeOptions.find(function (size) { return size.selected; }),
                paymentOptionsLayout: props.paymentOptionsLayout,
            }, {}, props.positions.paymentOptions),
            AddToCart: createComponentConfig(AddToCart, {
                product: product.value,
                bulletPoints: props.bulletPoints,
                checkoutSettings: props.checkoutSettings,
                grind: grindTypeOptions.find(function (grind) { return grind.selected; }),
                paymentPlan: paymentOptions.find(function (price) { return price.selected; }),
                planInterval: planIntervalOptions.find(function (interval) { return interval.selected; }),
                upsell: props.upsell,
            }, {}, props.positions.addToCart),
        }); });
        var orderedComponents = (0,vue_cjs.computed)(function () {
            return Object.values(components.value).sort(function (a, b) { return a.position - b.position; });
        });
        var imageOnLeft = (0,vue_cjs.computed)(function () { return props.positions.image === 'left'; });
        return function (_ctx, _cache) {
            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", {
                class: (0,vue_cjs.normalizeClass)({
                    'px-[48px] max-md:px-[16px]': true,
                    'pt-[24px] pb-[100px]': (0,vue_cjs.unref)(isAddToCartFixed),
                    'py-[24px]': !(0,vue_cjs.unref)(isAddToCartFixed),
                }),
                style: (0,vue_cjs.normalizeStyle)({ backgroundColor: backgroundColor.value })
            }, [
                (0,vue_cjs.createElementVNode)("div", BuyBoxV2Containervue_type_script_setup_true_lang_ts_hoisted_1, [
                    (0,vue_cjs.createElementVNode)("div", {
                        class: (0,vue_cjs.normalizeClass)([{
                                'order-1': imageOnLeft.value,
                                'order-2': !imageOnLeft.value,
                            }, "w-full md:w-1/2"])
                    }, [
                        ((0,vue_cjs.unref)(showOrderSummary))
                            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", BuyBoxV2Containervue_type_script_setup_true_lang_ts_hoisted_2, [
                                (0,vue_cjs.createElementVNode)("div", BuyBoxV2Containervue_type_script_setup_true_lang_ts_hoisted_3, [
                                    ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)(product.value.images, function (image, idx) {
                                        return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", {
                                            key: "image-".concat(idx),
                                            class: "swiper-slide"
                                        }, [
                                            (0,vue_cjs.createVNode)(BuyBoxV2Image, {
                                                "image-url": image.src,
                                                "image-alt": image.alt
                                            }, null, 8, ["image-url", "image-alt"])
                                        ]));
                                    }), 128))
                                ]),
                                BuyBoxV2Containervue_type_script_setup_true_lang_ts_hoisted_4
                            ]))
                            : ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", BuyBoxV2Containervue_type_script_setup_true_lang_ts_hoisted_5, [
                                (0,vue_cjs.createVNode)(BuyBoxV2Image, {
                                    "image-url": product.value.image,
                                    "image-alt": "".concat(product.value.title, " Coffees")
                                }, null, 8, ["image-url", "image-alt"])
                            ]))
                    ], 2),
                    (0,vue_cjs.createElementVNode)("div", {
                        class: (0,vue_cjs.normalizeClass)([{ 'order-1': !imageOnLeft.value, 'order-2': imageOnLeft.value }, "w-full flex-col flex gap-[24px]"])
                    }, [
                        ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)(orderedComponents.value, function (component) {
                            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)((0,vue_cjs.resolveDynamicComponent)(component.component), (0,vue_cjs.mergeProps)({
                                key: component.position,
                                ref_for: true
                            }, component.props, (0,vue_cjs.toHandlers)(component.emits)), null, 16));
                        }), 128))
                    ], 2)
                ])
            ], 6));
        };
    }
}));

;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/BuyBoxV2Container.vue?vue&type=script&setup=true&lang=ts
 
;// CONCATENATED MODULE: ./src/js/vue/buyBoxV2/BuyBoxV2Container.vue



const BuyBoxV2Container_exports_ = BuyBoxV2Containervue_type_script_setup_true_lang_ts;

/* harmony default export */ const BuyBoxV2Container = (BuyBoxV2Container_exports_);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-bundle.esm.js + 2 modules
var swiper_bundle_esm = __webpack_require__(3033);
;// CONCATENATED MODULE: ./src/js/sections/section.buy-box-v2.js




(0,create_vue_section/* createVueSection */.C)('buy-box-v2', BuyBoxV2Container);
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.buy-box-v2-carousel')) {
    new swiper_bundle_esm/* default */.A('.buy-box-v2-carousel', {
      direction: 'horizontal',
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      spaceBetween: 5,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      }
    });
  }
});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/runtimeId */
/******/ 	(() => {
/******/ 		__webpack_require__.j = 2727;
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			2727: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshopify_frontend"] = self["webpackChunkshopify_frontend"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	(() => {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [8096,2076], () => (__webpack_require__(6538)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;